
import React from "react";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";


// UPDATED to REACT 18
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>,
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
